import { useContext } from 'react';
import { store } from '../store';

const useOpposingTeamSelector = () => {
    const { state: { opponent } } = useContext(store);
    //const milbLevels = [1, 2, 3, 4, 5, 10];

    return {
        ...opponent,
        // eslint-disable-next-line no-nested-ternary
        //LevelIDData: opponent?.IsMajorLeague ? 8 : milbLevels.includes(opponent?.LevelID) ? 7 : 8,
        LevelIDData: (opponent?.LevelID === 8 || opponent?.Level?.LevelID === 8) ? 8 : 7,
    };
};

export default useOpposingTeamSelector;
